import { 
  statusAssuranceStart,
  statusAssuranceSuccess,
  statusAssuranceFailure 
} from "./assuranceSlice";
import { get, post, put, remove } from "../../requestMethods"

export const ShowAssuranceApi = () => async (dispatch: any) => {
  try {
    dispatch(statusAssuranceStart())
    const res = await get("assurance");
    const resData = res.data.success
    if(resData) {
      dispatch(statusAssuranceSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusAssuranceFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusAssuranceFailure(errData.err))
      return [errData.err]  
    }
  }
}

export const AddAssuranceApi = (assurance: any) => async (dispatch: any) => {
  try {
    dispatch(statusAssuranceStart())
    const response = await post("assurance", assurance)
    const resData  = await response.data.success
    if(resData) {
      dispatch(statusAssuranceSuccess(resData))
      return true;
    }
  } catch (err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusAssuranceFailure(formErrors))      
      return formErrors
    } else {
      dispatch(statusAssuranceFailure(errData.err))      
      return [errData.err]
    }
  }
}

export const EditAssuranceApi = (id: any, assurance: any) => async (dispatch: any) => {
  try {
    dispatch(statusAssuranceStart())
    const response = await put(`assurance/${id}`, assurance);
    const resData = response.data.success
    if(resData) {
      dispatch(statusAssuranceSuccess(resData))
      return true;
    }
  }catch (err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusAssuranceFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusAssuranceFailure(errData.err))
      return [errData.err]
    }
  }
}

export const DeleteAssuranceApi = (id: string) => async (dispatch: any) => {
  try {
    dispatch(statusAssuranceStart());
    const response = await remove(`assurance/${id}`);
    const resData = response.data.success
    if(resData) {
      dispatch(statusAssuranceSuccess(resData))
      return true;
    }
  } catch(err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusAssuranceFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusAssuranceFailure(errData.err))
      return errData.err
    }
  }
}

export const AddAssuranceSupportApi = (assId: any, support: any) => async (dispatch: any) => {
  try {
    dispatch(statusAssuranceStart())
    const response = await post(`assurance/${assId}/support`, support);
    const resData = response.data.success
    if(resData) {
      dispatch(statusAssuranceSuccess(resData))
      return true;
    }
  } catch(err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusAssuranceFailure(formErrors));
      return formErrors
    } else {
      dispatch(statusAssuranceFailure(errData.err));
      return [errData.err]
    }
  }
}

export const EditAssuranceSupportApi = (assId: string = "", support: any, supportId: string) => async (dispatch: any) => {
  try {
    dispatch(statusAssuranceStart())
    const response = await put(`assurance/${assId}/support/${supportId}`, support);
    const resData = response.data.success
    if(resData) {
      dispatch(statusAssuranceSuccess(resData));
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusAssuranceFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusAssuranceFailure(errData.err))
      return [errData.err]
    }
  }
}

export const DeleteAssuranceSupportApi = (assId: any, supportId: any) => async (dispatch: any) => {
  try {
    dispatch(statusAssuranceStart())
    const response = await remove(`assurance/${assId}/support/${supportId}`);
    const resData = response.data.success
    if(resData) {
      dispatch(statusAssuranceSuccess(resData));
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    const formErrors = errData.formErrors ? errData.formErrors : [errData];
    if(err.response && err.response.status === 300) {
      dispatch(statusAssuranceFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusAssuranceFailure(errData.err))
      return [errData.err]
    }
  }
} 


export const clearAssurancesApi = (dispatch: any) => {
  dispatch(statusAssuranceSuccess([]))
}